import { Component, OnInit } from '@angular/core';
import { RangeRingToolService } from 'src/app/map/services/range-ring-tool.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';



@Component({
  selector: 'app-range-ring-tool',
  templateUrl: './range-ring-tool.component.html',
  styleUrls: ['./range-ring-tool.component.scss'],
  standalone: false
})
export class RangeRingToolComponent implements OnInit {

  constructor(
    public rangeRingTool : RangeRingToolService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService : TabsService
  ) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.rangeRingTool.active = !this.rangeRingTool.active;
    this.toolsService.navigationOnTop = false;

    this.rangeRingTool.clearListeners();
  }

}
